query getDesignOptions($id: ID!) {
  design: getDesign(id: $id) {
    id
    options {
      id
      designId
      name
      isTrunk
      createdAt
      updatedAt
    }
  }
}

mutation createDesignOption($id: ID!, $input: CreateDesignOptionInput!) {
  option: createDesignOption(id: $id, input: $input) {
    id
    designId
    name
    isTrunk
    createdAt
    updatedAt
  }
}

mutation updateDesignOption(
  $id: ID!
  $optionId: ID!
  $input: UpdateDesignOptionInput!
) {
  option: updateDesignOption(id: $id, optionId: $optionId, input: $input) {
    id
    designId
    name
    isTrunk
    createdAt
    updatedAt
  }
}

mutation deleteDesignOption($id: ID!, $optionId: ID!) {
  deleteDesignOption(id: $id, optionId: $optionId) {
    deleted
  }
}
